<template>
    <div class="d-flex justify-content-between py-3 header-container ">
        <div>
            <div class="d-flex gap-2 align-items-center">
                <img src="../../../assets/images/title-icon.png" alt="">
                <h3>{{training.name}}</h3>
            </div>
        </div>
    </div>
    <div class="main-edit-container">
        <div class="template-details-container">
            <p class="template-name">
                <span class="template-header">Descriptive Template : </span>{{templateName}} &nbsp;&nbsp;
            </p>
                <router-link :to="'/templates/view/'+template_id_view" v-if="permissions.includes('viewAny template')" class="linkViewTemplate">
                    View Template
                </router-link>
            
        </div>
        <div class="btnOrganization ">
        </div>
    

        <div id="createUserContainer" class="tabcontent1">
            <div class="firstStartDate" v-if="training.start_date != null">
                <h6>Start Date</h6>
                <p>{{training.start_date}}</p>
            </div>
            <div class="firstStartDate" v-else>
                <h6>Start Date</h6>
                <p>Not Choosen</p>
            </div>

            <div class="secondEndDate" v-if="training.end_date != null">
                <h6>End Date</h6>
                <p>{{training.end_date}}</p>
            </div>
            <div class="secondEndDate" v-else>
                <h6>End Date</h6>
                <p>Not Choosen</p>
            </div>

            <div class="startTimeCss" v-if="training.start_time != null">
                <h6>Start Time</h6>
                <p>{{training.start_time}} GMT</p>
            </div>
            <div class="startTimeCss" v-else>
                <h6>Start Time</h6>
                <p>Not Choosen</p>
            </div>

            <div class="startTimeCss" v-if="training.end_time != null">
                <h6>End Time</h6>
                <p>{{training.end_time}} GMT</p>
            </div>
            <div class="startTimeCss" v-else>
                <h6>End Time</h6>
                <p>Not Choosen</p>
            </div>

            <div class="durationCss" v-if="training.duration != null">
                <h6>Duration</h6>
                <p>{{training.duration}} minutes</p>
            </div>
            <div class="durationCss" v-else>
                <h6>Duration</h6>
                <p>{{durationInTime}} minutes</p>
            </div>

            
            <!-- I found it commented, please keep it commented don't use your brain -->
            <!-- <div class="cssActionsStyle">
               <font-awesome-icon  :icon="['fas', 'trash']" class="trashDesign" v-if="permissions.includes('delete training')" @click.prevent="deleteTraining"  size="xl"/>
                &nbsp;&nbsp;&nbsp;&nbsp;
               <font-awesome-icon :icon="['fas', 'pen']" class="penDesign" size="xl" @click.prevent="EditTraining"/>
            </div> -->
        </div>

        <div v-if="training_type === 'private'">
            <div  v-if="usersAssignedData.length > 0" class="row w-100">
                <div class="d-flex justify-content-between mb-4">
                    <div>
                                       <!-- <h3>Users</h3> -->
                    </div>
                    <div class="btnOrganization2">
                        <button @click.prevent="AssignUserToTraining">Assign</button>
                    </div>
                </div>

                <div class="row d-flex styleFlex">
                    <div class="col-md-2 styleCssAssigned" v-for="user in usersAssignedData" :key="user.id">
                        <div class="styleUser">
                            {{user.participant.name}}
                        </div>
                        <div class="styleTrash">
                            <font-awesome-icon  :icon="['fas', 'trash']" class="trash" @click.prevent="deleteUser(user.id)"  size="lg"/>
                        </div>
                    </div>
                </div>
            </div>

            <div id="createUserContainer2" class="d-flex justify-content-center" v-else>
                <div class="assignUsersCss">
                    <div class="text-center mb-4">
                        <img src="../../../assets/images/surface1.svg" alt="" >
                    </div>
                    <div class="text-center mb-4">
                        <h5>No Users or Teams Are Assigned for This Trainings</h5>
                    </div>
                    <div class="buttonCssAssign text-center">
                        <button @click="AssignUserToTraining">Assign</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else></div>
    </div>
    <router-link class="back-route" ref="backBtn" @click="backHandler" :to="isFull ? '#':'/trainings'">
        <button class="back-btn">Back</button>
    </router-link>
    <AssignUsers @clickAssign="clickAssignHandler" v-if="this.isShow" :whoPlay="whoPlay" :participant="participant_type_data" :training_type="training_type" :message="confirmMessage" :confirmUsers="ChooseUsers" :confirmTeam="ChooseTeam"
                 @close-modal="this.isShow = false"
                 :confirmTeamLeader="ChooseTeamLeader"/>

    <ModalChooseUser @close-modal="closeModalHandler" v-if="this.isAssignFlag" :whoPlay="whoPlay" :participant="participant_type_data" :training_type="training_type" :message="chooseMessageText" :data="data" @assignUsers1="AssignUsers1" @assignUsers2="AssignUsers2"/>

    <AssignTeamLeader v-if="isShow2" @close-modal="closeModalTraining"  @success="ShowModalSuccess" :whoPlay="whoPlay" :message="confirmMessage" :participant="participant_type_data" :training_type="training_type" :confirmUsers="ChooseUsers" :confirmTeam="ChooseTeam" />

    <ConfirmationModal v-if="confirmModalFlag2" :message="confirmMessage" confirmBtn="Delete" cancleBtn="Cancel"
                       @close-modal="confirmModalHandler($event)"/>

    <ConfirmationModal v-if="confirmModalFlag3" :message="confirmMessage2" :id="training_user_id" confirmBtn="Delete" cancleBtn="Cancel"
                       @close-modal="confirmModalHandler2($event)"/>

    <AlartModal v-if="showModal" :message="message" :imagePath="ImagePath" @close-modal="showModal = false"/>
</template>

<script>
    import AssignUsers from '../../components/AssignUsers';
    import AssignTeamLeader from '../../components/AssignTeamLeader';
    import ModalChooseUser from '../../components/ModalChooseUsers';
    import training from "../../../api-services/training";
    import ConfirmationModal from "../../components/ConfirmationModal";
    import AlartModal from "../../components/AlartModal";
    import {computed} from "vue";
    import moment from "moment";
    import competition from "../../../api-services/competition";

    export default {
        name:'complete-edit-training',
        props:['ChooseUsers' , 'ChooseTeam' , 'ChooseTeamLeader' , 'AssignUsers' , 'success'],
        data(){
            return {
                isFull:false,
                isShow:false,
                isShow2:false,
                permissions:[],
                showModal:false,
                message:'',
                ImagePath:'',
                isAssignFlag: false,
                confirmModalFlag: false,
                confirmModalFlag2: false,
                confirmModalFlag3: false,
                training_user_id:null,
                isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
                isData:{

                },
                training:{
                    name:null,
                    template_id:null,
                    type:2,
                    start_date:null,
                    end_date:null,
                    start_time:null,
                    end_time:null,
                    duration:null
                },
                data: [],
                usersAssignedData:[],
                templateName:'',
                durationInTime:null,
                template_id_view:null,
                confirmMessage: '',
                confirmMessage2: '',
                chooseMessageText:'',
                training_type:null,
                participant_type_data:null,
                whoPlay:null
            }
        },
        components:{
            AssignUsers,
            ModalChooseUser,
            ConfirmationModal,
            AssignTeamLeader,
            AlartModal
        },
        async mounted(){
            this.getTraining();
            this.getUsersAssigned();
            this.permissions = this.$store.state.auth.permissions;
            const compData = await training.show(this.$route.params.id);
            this.training_type = compData.data.data.training_type;
            this.whoPlay = compData.data.data.is_play;
        },
        methods:{
            ShowModalSuccess(){
                const training_id = this.$route.params.id;
                this.isShow2 = false;
                this.showModal = true;
                this.ImagePath = 'okImage.svg';
                this.message = "Users Assigned Successfully";
                window.location.href="/complete-edit-trainings/"+training_id;
            },
            clickAssignHandler(event){
                this.isAssignFlag = true;
                this.data = event[1].data.data;
                this.chooseMessageText = event[0];
            },
            AssignUsers1(){
                const training_id = this.$route.params.id;
                this.isAssignFlag = false;
                this.isShow = false;
                this.showModal = true;
                this.ImagePath = 'okImage.svg';
                this.message = "Users Assigned Successfully";
                window.location.href = "/complete-edit-trainings/"+training_id;
            },

            AssignUsers2(){
                const training_id = this.$route.params.id;
                this.isAssignFlag = false;
                this.isShow = false;
                this.isShow2 = true;
            },

            closeModalHandler(e){
                this.isShow = false;
                this.isAssignFlag = false
            },

            async backHandler () {
                let setDataFlag = this.$store.state.settings.setDataFlag;
                if(setDataFlag){
                    this.isFull = true;
                    await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                }else {
                    await this.$store.dispatch('setDataFlag', false);
                    this.isFull = false
                }
            },
            async confirmModalHandler (event) {
                // await this.$store.dispatch('setConfirmModal', false);
                this.confirmModalFlag2 = false;
                if(event){
                    const training_id = this.$route.params.id;
                    await competition.delete(training_id);
                    // await this.$store.dispatch('setDataFlag', false);
                    this.confirmModalFlag2 = false;
                    await this.$router.push('/trainings');
                }
            },
            async confirmModalHandler2 (event) {
                this.confirmModalFlag3 = false;
                if(event){
                    const training_id = this.$route.params.id;
                    await training.deleteUserAssigned(this.training_user_id);

                    this.confirmModalFlag3 = false;
                    // await this.$router.push('/complete-edit-competitions/'+competition_id);
                    window.location.href = '/complete-edit-trainings/'+training_id;
                }
            },
            AssignUserToTraining(){
                this.isShow = true;
                this.confirmModalFlag = true;
                this.confirmMessage = 'Assign to';
            },
            async closeModalTraining(){
                const competition_id = this.$route.params.id;
                await competition.deleteCompetitionUsers(competition_id);
                this.isShow2 = false;
            },
            async getTraining(){
                const training_id = this.$route.params.id;
                try{
                    const response = await training.show(training_id);
                    if (process.env.VUE_ENV === 'development')
                    console.log(response);

                    this.training.name = response.data.data.name.charAt(0).toUpperCase() +  response.data.data.name.slice(1);
                    this.training.template_id = response.data.data.template_id;
                    this.training.start_date = moment(response.data.data.start_date).format('D-MMM-YYYY');
                    this.training.end_date = moment(response.data.data.end_date).format('D-MMM-YYYY');
                    this.training.start_time = response.data.data.start_time.slice(0,5);
                    this.training.end_time = response.data.data.end_time.slice(0,5);
                    this.training.duration = response.data.data.duration;
                    this.templateName = response.data.data.template.name;

                    if(this.training.duration === null){
                        let startTime = moment(this.training.start_time, "HH:mm:ss a");
                        let endTime = moment(this.training.end_time, "HH:mm:ss a");
                        let duration  = moment.duration(endTime.diff(startTime));
                        let hours = parseInt(duration.asHours()) * 60;
                        let minutes = parseInt(duration.asMinutes()) % 60;

                        this.durationInTime = (hours+minutes);
                    }

                    this.template_id_view = response.data.data.template.id;
                }catch(e) {
                    if (process.env.VUE_ENV === 'development')
                    console.log(e);
                }
            },
            async getUsersAssigned(){
                const training_id = this.$route.params.id;
                try{
                    const response = await training.getUsersAssigned(training_id);
                    if (process.env.VUE_ENV === 'development')
                    console.log(response.data.data);
                    this.usersAssignedData = response.data.data;
                }catch(e){
                    if (process.env.VUE_ENV === 'development')
                    console.log(e);
                }
            },
            deleteTraining(){
                this.confirmModalFlag2 = true;
                this.confirmMessage = 'Do you want to delete this competition?';
            },
            EditTraining(){
                const competition_id = this.$route.params.id;
                this.$router.push({path: "/edit-trainings/"+competition_id});
            },
            deleteUser(e){
                try{
                    this.training_user_id = e;
                    this.confirmModalFlag3 = true;
                    this.confirmMessage2 = 'Do you want to delete this user?';
                }catch(error){
                    if (process.env.VUE_ENV === 'development')
                    console.log(error);
                }
            },
            async SaveTraining(){
                try{
                    const training_id = this.$route.params.id;

                    if(this.training.start_time === null && this.training.end_time === null){
                        this.training.date_type = 2;
                    }else{
                        this.training.date_type = 1;
                    }
                    await training.update(training_id , {
                        name:this.training.name,
                        template_id:this.template_id_view,
                        type:2,
                        date_type:this.training.date_type,
                        start_date:this.training.start_date,
                        end_date:this.training.end_date,
                        start_time:this.training.start_time,
                        end_time:this.training.end_time,
                        duration:this.training.duration,
                    });
                    await this.$store.dispatch('setDataFlag', false);

                    this.$router.push({path: "/trainings"});
                }catch(e){
                    if (process.env.VUE_ENV === 'development')
                    console.log(e);
                }
            }
        }
    }
</script>

<style scoped>
    .header-container{
        padding-inline: 30px;
    }
    h3{
        margin: 0;
        text-transform: uppercase;
    }
    .back-route{
        margin-top: 2vh;
        display: flex;
        justify-content: end;
        width:100%;
        height: 35px;
        padding-inline: 30px;
    }
    .back-btn{
        background-color: #707070 !important;
        padding: 0px 50px;
        text-decoration: none;
        cursor: pointer;
        color: #FFF;
        font-size: 18px;
        border: 0;
        border-radius: 5px;
    }

    .main-edit-container{
        margin-inline: 30px;
        background-color: #022B3C;
        padding: 30px;
        border-radius: 5px;
        height: 63vh;
        overflow-y: auto;
    }
    .assigned-user-container{
        padding: 30px;
        background-color: #023144;
        border: 1px solid rgba(200, 200, 200,0.1);
        border-radius: 10px;
    }
    .template-details-container{
        margin-bottom:20px;
    }
    .template-name{
        font-size: 18px;
        padding: 0;
    }
    .template-header{
        color:#37A6A2;
        font-size: 18px;
        font-weight: 600;
    }
    .styleInIPad{
        margin-bottom: 3rem;
    }
    .styleTrash{
        position:absolute;
    }
    .trash{
        position: relative;
        top:12px;
        left: 260px;
        color: #FF7171;
        cursor: pointer;
    }
    .styleUser{
        display: flex;
        align-items: center;
        padding-left: 10px;
    }
    .styleFlex{
        gap:50px;
    }
    .styleCssAssigned{
        position: relative;
        display: flex;
        border: 1px solid #39525C;
        width: 300px;
        height: 50px;
        border-radius: 6px;
    }
    .btnOrganization2 button {
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
        border: none;
        border-radius: 5px;
        justify-content: end;
        /*align-content: center;*/
        width: 140px;
        padding: 10px;
    }
    .tabcontent1 div p{
        font-size: 1.5rem !important;
    }
    .tabcontent1 div p{
        font-size: 1rem !important;
    }

    .btnOrganization button {
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
        border: none;
        border-radius: 5px;
        justify-content: end;
        align-content: center;
        padding: 10px;
    }

    .buttonCssAssign button{
        border:none;
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
        padding: 10px 70px;
        border-radius: 5px;
    }
    .penDesign {
        color: #00970A;
        cursor: pointer;
    }
    .trashDesign {
        color: #FF7171;
        cursor: pointer;
    }
    .cssActionsStyle{
        width: 370px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .secondEndDate,
    .firstStartDate,
    .startTimeCss,
    .durationCss{
        width:auto;
    }
    .linkViewTemplate{
        color:#e65c00;
    }
    .assignUsersCss{
        width:100%;
        padding: 30px;
        height: auto;
        background-color: #023144;
        border: 1px solid rgba(200, 200, 200,0.1);
        border-radius: 15px;
    }
    .tabcontent1{
        display: flex;
        justify-content: space-between;
        align-items: center !important;
        padding: 20px;
        height: 15vh;
        background-color: #023144;
        border: 1px solid rgba(200, 200, 200,0.1);
        border-radius: 10px;
        margin-bottom: 10px;
    }

    @media(max-width:1280px){
        .tabcontent1 div p{
            font-size: 1.2rem !important;
        }
    }
</style>